import { ServiceFetch } from './service-fetch'

export default class CustomerModel extends ServiceFetch {
    getCustomerTierBy = (data) => this.authFetch({
        url: 'customer-tier/getCustomerTierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
    getCustomerTierByCode = (data) => this.authFetch({
        url: 'customer-tier/getCustomerTierByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}